const itemEls = document.querySelectorAll('[data-footer-item]')
let resizeTimeout

function handleItemClick() {
  const isOpened = this.classList.toggle('opened')
  const hiddenBlock = this.nextElementSibling
  hiddenBlock.style.height = isOpened ? 'fit-content' : '0'

  const otherItemEls = [...itemEls].filter(el => el !== this)
  otherItemEls.forEach(el => {
    el.classList.remove('opened')
    el.nextElementSibling.style.height = '0'
  })
}

function addClickListeners() {
  itemEls.forEach(el => {
    el.addEventListener('click', handleItemClick)
  })
}

function removeClickListeners() {
  itemEls.forEach(el => {
    el.removeEventListener('click', handleItemClick)
  })
}

export function checkScreenWidth() {
  const screenWidth =
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const isMobile = screenWidth < 768

  if (isMobile) {
    addClickListeners()
  } else {
    removeClickListeners()
  }

  itemEls.forEach(el => {
    const hiddenBlock = el.nextElementSibling
    hiddenBlock.style.height = isMobile ? '0' : 'fit-content'
  })

  const openedItem = document.querySelector('.opened[data-footer-item]')
  if (openedItem && isMobile) {
    openedItem.nextElementSibling.style.height = 'fit-content'
  }
}

function handleResize() {
  clearTimeout(resizeTimeout)
  resizeTimeout = setTimeout(checkScreenWidth, 100)
}

// Initial check when the page loads
checkScreenWidth()

// Check screen width when changing
window.addEventListener('resize', handleResize)
